export const MARKDOWN_CONTEXT = 'markdown';
export const MARKDOWN_STYLE_CONTEXT = 'markdown-style';
export const MARKDOWN_SAFETY_CONTEXT = 'markdown-safety';
